var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (item) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: item.permissson,
                class: ["tabItem", _vm.active === item.type ? "active" : ""],
                on: {
                  click: function ($event) {
                    return _vm.changeType(item.type, item.permissson)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.name) +
                    " (" +
                    _vm._s(
                      _vm.tabNumer.find((a) => a.type === item.type)?.qty || 0
                    ) +
                    ") "
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: { placeholder: "请输入单号/参考单号搜索" },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.search.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.filterList.search,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterList, "search", $$v)
                    },
                    expression: "filterList.search",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "btn-search", on: { click: _vm.search } },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("导出"),
                    expression: "computedPermissions('导出')",
                  },
                ],
                staticClass: "derive flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("导出") },
                on: { click: _vm.derive },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/const/derive.png"),
                    alt: "导出",
                  },
                }),
                _vm._v(" 导出 "),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.computedPermissions("新增"),
                    expression: "computedPermissions('新增')",
                  },
                ],
                staticClass: "add flex_c_c",
                attrs: { "v-permissson": _vm.computedPermissions("新增") },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible1 = true
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: { className: "icon", iconClass: "add" },
                }),
                _vm._v("新增 "),
              ],
              1
            ),
            _c(
              "BaseFilter",
              {
                attrs: { width: 488, isActive: _vm.isActive },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { model: _vm.filterList, "label-width": "84px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "创建时间" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "320px" },
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            align: "center",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "unlink-panels": "",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.filterList.date,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterList, "date", $$v)
                            },
                            expression: "filterList.date",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "进入时间" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "320px" },
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            align: "center",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                            "unlink-panels": "",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.filterList.entryDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterList, "entryDate", $$v)
                            },
                            expression: "filterList.entryDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请选择类型", multiple: "" },
                            model: {
                              value: _vm.filterList.companyIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterList, "companyIds", $$v)
                              },
                              expression: "filterList.companyIds",
                            },
                          },
                          _vm._l(_vm.companyDrapdown, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "业务类型" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请选择类型", multiple: "" },
                            model: {
                              value: _vm.filterList.otherServiceTypeIds,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filterList,
                                  "otherServiceTypeIds",
                                  $$v
                                )
                              },
                              expression: "filterList.otherServiceTypeIds",
                            },
                          },
                          _vm._l(_vm.otherServiceTypeOptions, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.typeName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c(
                "BaseTable",
                {
                  key: _vm.active,
                  attrs: {
                    height: _vm.height,
                    tableData: {
                      ..._vm.tableData,
                      fileds: _vm.fileds,
                    },
                    pageIndex: _vm.pager.pageIndex,
                    pageSize: _vm.pager.pageSize,
                    loading: _vm.loading,
                    isEmptyBorder: true,
                  },
                  on: {
                    handleSelectionChange: _vm.handleSelectionChange,
                    handlePageChange: _vm.handlePageChange,
                    sortChange: _vm.sortChange,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "attachmentCount",
                        fn: function (row) {
                          return [
                            _vm._v(
                              " " + _vm._s(row.scope.attachmentCount) + " "
                            ),
                            _c("img", {
                              staticClass: "attachments",
                              attrs: {
                                src: require("@/assets/images/other/attachments.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.attachments(row.scope)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "otherServiceType",
                        fn: function (row) {
                          return _c(
                            "div",
                            { staticClass: "otherServiceType" },
                            _vm._l(row.scope.otherServiceType, function (item) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticClass: "type-item flex_c_c",
                                },
                                [_vm._v(" " + _vm._s(item.typeName) + " ")]
                              )
                            }),
                            0
                          )
                        },
                      },
                      {
                        key: "receivableStatus",
                        fn: function (row) {
                          return _c(
                            "div",
                            {
                              class: [
                                "receivableStatus",
                                "flex_c_c",
                                `receivableStatus${row.scope.receivableStatus}`,
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formartPayStatus")(
                                      row.scope.receivableStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "payableStatus",
                        fn: function (row) {
                          return _c(
                            "div",
                            {
                              class: [
                                "receivableStatus",
                                "flex_c_c",
                                `receivableStatus${row.scope.payableStatus}`,
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formartPayStatus")(
                                      row.scope.payableStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "receivableAmount",
                        fn: function (row) {
                          return _c(
                            "span",
                            { staticStyle: { color: "#fe453d" } },
                            [
                              _vm._v(
                                " $ " + _vm._s(row.scope.receivableAmount) + " "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "payableAmount",
                        fn: function (row) {
                          return _c(
                            "span",
                            { staticStyle: { color: "#fe453d" } },
                            [
                              _vm._v(
                                " $ " + _vm._s(row.scope.payableAmount) + " "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "auditStatus",
                        fn: function (row) {
                          return _c(
                            "div",
                            {
                              class: [
                                "auditStatus",
                                "flex_c_c",
                                `auditStatus${row.scope.auditStatus}`,
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formartAuditStatus")(
                                      row.scope.auditStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        },
                      },
                      {
                        key: "opt",
                        fn: function (row) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: `popover${row.scope.id}`,
                                attrs: {
                                  placement: "bottom-start",
                                  "popper-class": "pop-table-opt",
                                  width: "114",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("div", { staticClass: "table-opt" }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions("修改"),
                                              expression:
                                                "computedPermissions('修改')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("修改"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.update(row.scope)
                                            },
                                          },
                                        },
                                        [_vm._v("修改")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions("作废"),
                                              expression:
                                                "computedPermissions('作废')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("作废"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.operat(row.scope, -1)
                                            },
                                          },
                                        },
                                        [_vm._v("作废")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions("审核"),
                                              expression:
                                                "computedPermissions('审核')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("审核"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.operat(row.scope, 0)
                                            },
                                          },
                                        },
                                        [_vm._v("审核")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions(
                                                  "反审核"
                                                ),
                                              expression:
                                                "computedPermissions('反审核')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("反审核"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.operat(row.scope, -2)
                                            },
                                          },
                                        },
                                        [_vm._v("反审核")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions("完成"),
                                              expression:
                                                "computedPermissions('完成')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("完成"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.operat(row.scope, 1)
                                            },
                                          },
                                        },
                                        [_vm._v("完成")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.computedPermissions("删除"),
                                              expression:
                                                "computedPermissions('删除')",
                                            },
                                          ],
                                          staticClass: "opt-item",
                                          attrs: {
                                            "v-permissson":
                                              _vm.computedPermissions("删除"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteRow(row.scope)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("img", {
                                  staticStyle: { "margin-left": "-14px" },
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/table/opt.png"),
                                  },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2913364085
                  ),
                },
                [
                  _c("template", { slot: "custom-total" }, [
                    _c("div", { staticClass: "custom-total" }, [
                      _c("span", [
                        _vm._v(
                          "已选 " + _vm._s(_vm.selectionItem.length) + " 项"
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.computedPermissions("批量完结"),
                              expression: "computedPermissions('批量完结')",
                            },
                          ],
                          staticClass: "flex_c_c finished",
                          attrs: {
                            "v-permissson": _vm.computedPermissions("批量完结"),
                          },
                          on: { click: _vm.batchComplete },
                        },
                        [_vm._v(" 批量完结 ")]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.computedPermissions("删除"),
                              expression: "computedPermissions('删除')",
                            },
                          ],
                          staticClass: "delete flex_c_c",
                          attrs: {
                            "v-permissson": _vm.computedPermissions("删除"),
                          },
                          on: { click: _vm.batchDelete },
                        },
                        [
                          _c("i", { staticClass: "el-icon-delete" }),
                          _vm._v("删除 "),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.computedPermissions("更新状态"),
                              expression: "computedPermissions('更新状态')",
                            },
                          ],
                          staticClass: "renewal flex_c_c",
                          attrs: {
                            "v-permissson": _vm.computedPermissions("更新状态"),
                          },
                          on: { click: _vm.renewal },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/other/renewal.png"),
                            },
                          }),
                          _vm._v("更新状态 "),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c("AddOtherServiceDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible1,
          supplierOptions: _vm.supplierOptions,
          otherServiceTypeOptions: _vm.otherServiceTypeOptions,
          rowData: _vm.rowData,
        },
        on: { cancel: _vm.cancel, ok: _vm.ok },
      }),
      _c("AttachmentListDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2, rowData: _vm.rowData },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.ok,
        },
      }),
      _c("RenewalStatusDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          otherServiceIDs: _vm.selectionItem.map((a) => a.id),
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
          ok: _vm.ok,
        },
      }),
      _c("AuditFeeDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible4,
          type: _vm.type,
          rowData: _vm.rowData,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible4 = false
          },
          ok: _vm.ok,
        },
      }),
      _c("BatchPaymentDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible5,
          selectionItem: _vm.selectionItem,
          type: 10,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible5 = false
          },
          ok: _vm.ok,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }